module.exports = __webpack_public_path__ + "img/hx_4.9676f0f5.jpg";